/* eslint-disable */
import * as React from "react";
import { useState } from "react";
import { motion } from "framer-motion";
import { wrap } from "popmotion";
import "../../asset/css/mainVisual.css";
import gongsaero_logo_only from "../../asset/images/gongsaero_logo_only.png";
import gongsaero_logo_title from "../../asset/images/gongsaero_logo_title.svg";
import bg_image from "../../asset/images/main_visual_bg.jpg";
import DemoModal from "../modal/DemoModal";
import mv1 from "../../asset/images/mv_1.png";
import mv2 from "../../asset/images/mv_2.png";
import mv3 from "../../asset/images/mv_3.png";
import mv4 from "../../asset/images/mv_4.png";

export default function MainVisual() {
  const sectionVariants = {
    offscreen: {
      x: -300,
    },
    onscreen: {
      x: 0,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8,
      },
    },
  };
  const moveVariants = {
    offscreen: {
      // x: -300,
      opacity: 0,
    },
    onscreen: {
      // x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 1.8,
      },
    },
  };

  const mvCardList = [
    {
      title: "Productivity",
      img: mv1,
      contents: "Revolutionizing productivity by reducing the business process by more than 50%",
    },
    { title: "Reduce Costs", img: mv2, contents: "Cost reduction performance of more than 30%." },
    {
      title: "Saving Time",
      img: mv3,
      contents: "Reduces the waste of time procuring materials and enables timely delivery.",
    },
    {
      title: "ESG",
      img: mv4,
      contents: "Creation ESG win-win value through transparent and fair matching algorithms.",
    },
  ];
  const [demoModal, setDemoModal] = useState(false);

  const handleVideoClick = () => {
    const newTabUrl = "https://youtu.be/e2eyBItQLcA?si=wEq2sRvFQ0ziDvgn";

    window.open(newTabUrl, "_blank");
  };
  return (
    <>
      <div className="main_visual_container_outer">
        <div className="main_visual_container">
          <div className="mv_inner">
            <div className="mv_header">
              <div className="mv_logo_container">
                <img src={gongsaero_logo_only} className="mv_logo" />
                <span className="mv_logo_title">Gongsaero</span>
              </div>
            </div>

            <motion.div
              className="mv_center"
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true, amount: 0.8 }}
            >
              <motion.div variants={sectionVariants} className="mv_center_title_container">
                <span className="mv_center_title1">Gongsaero</span>
                {/* <motion.svg className="mv_center_title2" viewBox="0 0 480 480" xmlns="http://www.w3.org/2000/svg">
                <motion.path
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  transition={{
                    duration: 4,
                    ease: "easeInOut",
                    // repeat: Infinity,
                    repeatType: "loop",
                    repeatDelay: 5,
                  }}
                  strokeWidth={1}
                  strokeDasharray="0 1"
                  stroke="white"
                  fill="white"
                  d="M35.4727 77.008C15.3882 77.008 0 63.5542 0 38.755C0 14.257 15.7879 0 35.4727 0C46.0646 0 53.4589 4.61847 58.2552 9.43775L50.4612 18.9759C46.764 15.4618 42.5673 12.751 35.9723 12.751C23.5819 12.751 15.0884 22.3896 15.0884 38.253C15.0884 54.5181 22.4827 64.1566 36.9716 64.1566C40.5688 64.1566 44.166 63.1526 46.2644 61.4458V46.7872H33.0746V34.6386H59.4543V68.0723C54.4581 73.0924 45.6649 77.008 35.4727 77.008Z 
                  M97.5047 77.008C83.4155 77.008 70.6254 66.1647 70.6254 47.5904C70.6254 28.9157 83.4155 18.0723 97.5047 18.0723C111.494 18.0723 124.284 28.9157 124.284 47.5904C124.284 66.1647 111.494 77.008 97.5047 77.008ZM97.5047 65.0602C105.099 65.0602 109.296 58.1325 109.296 47.5904C109.296 36.9478 105.099 30.1205 97.5047 30.1205C89.8106 30.1205 85.6138 36.9478 85.6138 47.5904C85.6138 58.1325 89.8106 65.0602 97.5047 65.0602Z
                  M136.672 75.6024V19.4779H148.563L149.762 26.9076H150.062C154.858 22.0884 160.654 18.0723 168.248 18.0723C180.239 18.0723 185.535 26.506 185.535 40.5622V75.6024H170.846V42.4699C170.846 33.6345 168.348 30.7229 162.952 30.7229C158.356 30.7229 155.458 32.9317 151.361 36.9478V75.6024H136.672Z
                  M220.27 100C207.18 100 196.988 95.4819 196.988 85.6426C196.988 80.9237 199.786 76.8072 204.982 73.996V73.494C202.084 71.5863 199.886 68.5743 199.886 63.9558C199.886 59.739 202.684 55.9237 206.181 53.5141V53.1124C202.284 50.3012 198.587 44.9799 198.587 38.3534C198.587 25.1004 209.379 18.0723 221.17 18.0723C224.367 18.0723 227.365 18.5743 229.663 19.4779H249.848V30.3213H240.255C241.754 32.2289 242.853 35.3414 242.853 38.755C242.853 51.506 233.26 57.8313 221.17 57.8313C218.971 57.8313 216.473 57.4297 213.975 56.5261C212.476 57.9317 211.577 59.1366 211.577 61.4458C211.577 64.3574 213.875 66.0643 220.37 66.0643H229.963C243.453 66.0643 250.847 70.1807 250.847 80.1205C250.847 91.4659 238.956 100 220.27 100ZM221.17 48.7952C226.066 48.7952 229.963 44.9799 229.963 38.3534C229.963 31.7269 226.166 28.1124 221.17 28.1124C216.273 28.1124 212.377 31.7269 212.377 38.3534C212.377 44.9799 216.273 48.7952 221.17 48.7952ZM222.569 90.6627C230.962 90.6627 236.658 86.9478 236.658 82.6305C236.658 78.6145 233.36 77.51 227.365 77.51H220.57C217.173 77.51 214.875 77.3092 212.876 76.7068C210.278 78.8153 209.179 81.0241 209.179 83.3333C209.179 88.0522 214.375 90.6627 222.569 90.6627Z
                  M276.295 77.008C268.801 77.008 260.507 73.7952 255.012 69.1767L261.607 59.8394C266.703 63.755 271.399 66.0643 276.595 66.0643C282.191 66.0643 284.789 63.5542 284.789 60.0402C284.789 55.9237 278.893 53.9157 273.098 51.7068C266.003 48.8956 258.109 44.6787 258.109 35.1406C258.109 25.2008 266.103 18.0723 278.893 18.0723C286.987 18.0723 293.382 21.3855 297.979 25L291.284 33.8353C287.387 31.0241 283.39 29.0161 279.293 29.0161C274.197 29.0161 271.899 31.2249 271.899 34.5382C271.899 38.5542 276.995 40.1606 282.99 42.2691C290.384 45.0803 298.478 48.8956 298.478 59.2369C298.478 69.1767 290.784 77.008 276.295 77.008Z
                  M323.471 77.008C313.478 77.008 306.983 69.9799 306.983 60.3414C306.983 48.3936 316.676 42.0683 339.159 39.5582C338.859 34.0361 336.561 29.9197 329.666 29.9197C324.47 29.9197 319.374 32.1285 314.278 35.241L308.982 25.4016C315.577 21.3855 323.471 18.0723 332.364 18.0723C346.553 18.0723 353.847 26.506 353.847 42.8715V75.6024H341.857L340.757 69.6787H340.358C335.462 73.8956 329.866 77.008 323.471 77.008ZM328.267 65.4619C332.464 65.4619 335.561 63.5542 339.159 60.0402V48.6948C325.469 50.4016 320.973 54.1165 320.973 59.2369C320.973 63.5542 323.97 65.4619 328.267 65.4619Z
                  M393.199 77.008C377.511 77.008 365.321 66.1647 365.321 47.5904C365.321 29.3173 378.111 18.0723 391.301 18.0723C406.789 18.0723 414.683 29.3173 414.683 44.8795C414.683 47.6908 414.383 50.3012 414.083 51.7068H379.51C380.809 60.9438 386.804 65.6627 395.098 65.6627C399.594 65.6627 403.591 64.257 407.688 61.747L412.584 70.8835C407.088 74.6988 400.094 77.008 393.199 77.008ZM379.31 41.8675H402.192C402.192 34.2369 398.795 29.4177 391.6 29.4177C385.705 29.4177 380.509 33.6345 379.31 41.8675Z
                  M426.879 75.6024V19.4779H438.77L439.969 29.4177H440.268C444.265 21.988 450.361 18.0723 456.156 18.0723C459.154 18.0723 460.953 18.4739 462.651 19.2771L460.153 31.9277C458.155 31.4257 456.656 31.0241 454.258 31.0241C449.961 31.0241 444.665 34.0361 441.567 42.1687V75.6024H426.879Z
                  M492.221 77.008C478.131 77.008 465.341 66.1647 465.341 47.5904C465.341 28.9157 478.131 18.0723 492.221 18.0723C506.21 18.0723 519 28.9157 519 47.5904C519 66.1647 506.21 77.008 492.221 77.008ZM492.221 65.0602C499.815 65.0602 504.012 58.1325 504.012 47.5904C504.012 36.9478 499.815 30.1205 492.221 30.1205C484.527 30.1205 480.33 36.9478 480.33 47.5904C480.33 58.1325 484.527 65.0602 492.221 65.0602Z
                  "
                />
              </motion.svg> */}
                <span className="mv_center_title2">Smart City Builder</span>
                <div className="mv_center_title3">
                  <div className="mv_center_title3-1">
                    <span>For Sustainable&nbsp;</span>
                    <span>Smart city</span>
                  </div>
                  <div className="mv_center_title3-2">
                    <span>We Build&nbsp;</span>
                    <span>New DX Way</span>
                  </div>
                  <span></span>
                </div>
                <div className="my_center_btn_container">
                  <motion.div
                    className="mv_center_btn1"
                    whileHover={{ scale: 1.05 }}
                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                    onClick={handleVideoClick}
                  >
                    Watch video
                  </motion.div>
                  <motion.div
                    className="mv_center_btn2"
                    whileHover={{ scale: 1.05 }}
                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                    onClick={() => setDemoModal(true)}
                  >
                    Request Demo
                  </motion.div>
                </div>
              </motion.div>
            </motion.div>

            <div className="mv_card">
              {mvCardList.map((a, i) => {
                return (
                  <motion.div
                    className="mv_card_inner"
                    initial="offscreen"
                    whileInView="onscreen"
                    viewport={{ once: true, amount: 0.8 }}
                    variants={moveVariants}
                  >
                    <motion.img src={a.img} className="mv_card_img" />
                    <span className="mv_card_title">{a.title}</span>
                    <span className="mv_card_contents">{a.contents}</span>
                  </motion.div>
                );
              })}
            </div>
            {/* 선 */}
            <motion.svg className="icon1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080">
              <motion.path
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                style={{ opacity: 0.3 }}
                transition={{
                  duration: 3,
                  ease: "easeInOut",
                  repeat: 0,
                  repeatType: "loop",
                  repeatDelay: 5,
                }}
                strokeWidth={3}
                strokeDasharray="0 1"
                stroke="#f6f6f8"
                fill="transparent"
                d="M86.6,780c0,0,318.7-503.1,720.5,0c0,0,206.2-334.2,519.1-88.9c0,0,294-369.8,435-80"
              />
            </motion.svg>

            {/* ai 구름 */}
            <motion.svg className="icon2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.5 283.5">
              <motion.path
                initial={{ y: 200, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  duration: 3,
                  ease: "easeInOut",
                  repeat: 0,
                  repeatType: "loop",
                  repeatDelay: 5,
                  delay: 2,
                }}
                strokeWidth={2}
                strokeDasharray="0 1"
                stroke="#fff"
                fill="#fff"
                d="M120.7,124.1h-0.6c-2.1,9-4.5,18.2-7,26.8l-2.4,9h19.5l-2.4-9C125.2,142.3,123,132.9,120.7,124.1z M216,132.7c-3,0-5.8,0.3-8.6,1c-3-35.2-31.9-62.8-67.1-62.8c-29,0-53.7,18.6-63.2,44.8c-0.4,0-0.8,0-1.2,0
              c-26.2,0-47.5,21.7-47.5,48.5c0,26.8,21.3,48.5,47.5,48.5H216c21.6,0,39.1-17.9,39.1-39.9C255.1,150.6,237.6,132.7,216,132.7z
               M139.5,193.5l-5.7-21h-26.5l-5.7,21H84.9l26.2-81.9h19.2l26.3,81.9H139.5z M182.6,193.5h-16.4v-81.9h16.4V193.5z"
              />
            </motion.svg>

            {/* 마커 */}
            <motion.svg className="icon4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46">
              <motion.path
                initial={{ y: 200, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  duration: 3,
                  ease: "easeInOut",
                  repeat: 0,
                  repeatType: "loop",
                  repeatDelay: 5,
                  delay: 2,
                }}
                strokeWidth={2}
                strokeDasharray="0 1"
                stroke="#fff"
                fill="#fff"
                d="M141.73,28.35c-40.48,0-73.29,32.81-73.29,73.29c0,40.48,73.29,153.48,73.29,153.48s73.29-113,73.29-153.48
              C215.02,61.16,182.21,28.35,141.73,28.35z M141.73,125.97c-16.58,0-30.03-13.44-30.03-30.03c0-16.58,13.44-30.03,30.03-30.03
              s30.03,13.44,30.03,30.03C171.76,112.53,158.32,125.97,141.73,125.97z"
              />
            </motion.svg>

            {/* bigdata 구름 */}
            <motion.svg className="icon5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46">
              <motion.path
                initial={{ y: 200, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  duration: 3,
                  ease: "easeInOut",
                  repeat: 0,
                  repeatType: "loop",
                  repeatDelay: 5,
                  delay: 2,
                }}
                strokeWidth={2}
                strokeDasharray="0 1"
                stroke="#fff"
                fill="#fff"
                d="M91.2,150.3h-2.5v27.7h2.5c7.6,0,12.3-4.1,12.3-14C103.5,154,98.8,150.3,91.2,150.3z M125.3,175.5c0,2.4,1.7,3.5,4.1,3.5c2.3,0,4-1.1,6-3v-6.2C127.8,170.6,125.3,172.7,125.3,175.5z M113.4,112.5h-5.7v11.9h5.7c5.6,0,8.6-2,8.6-6.2C122,114.2,119,112.5,113.4,112.5z M164.4,115.9c2.7,0,4.8-2,4.8-5.7c0-3.6-2.1-5.6-4.8-5.6s-4.8,2-4.8,5.6C159.6,113.9,161.7,115.9,164.4,115.9z M165.1,138.9c4.6,0,7.8-2,7.8-4.5c0-2.2-1.8-2.8-5.1-2.8h-3.7c-1.9,0-3.2-0.2-4.3-0.4c-1.4,1.1-2,2.3-2,3.6
              C157.8,137.4,160.7,138.9,165.1,138.9z M119.9,101.2c0-3.6-2.4-5-7.3-5h-4.8v10.3h4.7C117.6,106.5,119.9,104.4,119.9,101.2z M178.6,175.5c0,2.4,1.7,3.5,4.1,3.5c2.3,0,4-1.1,6-3v-6.2C181.1,170.6,178.6,172.7,178.6,175.5z M215.1,123.3c-3,0-5.8,0.3-8.6,1c-3-35.2-31.9-62.8-67.1-62.8c-29,0-53.7,18.6-63.2,44.8c-0.4,0-0.8,0-1.2,0
              c-26.2,0-47.5,21.7-47.5,48.5c0,26.8,21.3,48.5,47.5,48.5h140.1c21.6,0,39.1-17.9,39.1-39.9C254.3,141.1,236.7,123.3,215.1,123.3z
               M152.7,124.3c0-2.3,1.6-4.5,3.5-5.8v-0.2c-2.1-1.5-4.1-4.5-4.1-8.1c0-7.2,5.9-11.1,12.4-11.1c1.7,0,3.4,0.3,4.6,0.8h11.1v5.9h-5.2
              c0.8,1,1.4,2.7,1.4,4.7c0,6.9-5.3,10.4-11.9,10.4c-1.2,0-2.6-0.3-4-0.7c-0.8,0.7-1.3,1.4-1.3,2.6c0,1.6,1.2,2.5,4.8,2.5h5.2
              c7.4,0,11.5,2.3,11.5,7.7c0,6.2-6.5,10.9-16.8,10.9c-7.3,0-12.9-2.5-12.9-7.9c0-2.6,1.6-4.8,4.4-6.4v-0.3
              C153.9,128.4,152.7,126.8,152.7,124.3z M92.2,184.5H80.5v-40.8h11.2c12.4,0,20.1,6.5,20.1,20.2C111.8,177.7,104.1,184.5,92.2,184.5
              z M99.6,130.6V89.9H113c8.4,0,14.7,2.5,14.7,10.1c0,3.7-2.1,7.6-5.6,8.8v0.3c4.4,1,7.6,4.1,7.6,9.6c0,8.2-6.8,12-15.8,12H99.6z
               M143.4,184.5h-6.6l-0.5-3.3H136c-2.7,2.3-5.8,4.1-9.3,4.1c-5.5,0-9.1-3.9-9.1-9.1c0-6.6,5.3-10.1,17.8-11.4
              c-0.2-3-1.5-5.3-5.3-5.3c-2.9,0-5.6,1.3-8.5,2.9l-2.9-5.3c3.6-2.3,8-4.1,12.9-4.1c7.8,0,11.8,4.7,11.8,13.6V184.5z M144.5,130.6
              h-8.1V99.8h8.1V130.6z M140.4,94.9c-2.8,0-4.7-1.8-4.7-4.5c0-2.6,1.9-4.4,4.7-4.4c2.7,0,4.7,1.8,4.7,4.4
              C145.1,93.1,143.2,94.9,140.4,94.9z M161.9,185.3c-7.3,0-10.1-4.7-10.1-11.5v-13.6h-4.3v-6l4.8-0.4l0.9-8.3h6.7v8.3h7.6v6.4h-7.6
              v13.6c0,3.5,1.4,5.2,4.2,5.2c1,0,2.2-0.3,3-0.7l1.3,5.9C166.7,184.7,164.6,185.3,161.9,185.3z M196.7,184.5h-6.6l-0.5-3.3h-0.2
              c-2.7,2.3-5.8,4.1-9.3,4.1c-5.5,0-9.1-3.9-9.1-9.1c0-6.6,5.3-10.1,17.8-11.4c-0.2-3-1.5-5.3-5.3-5.3c-2.9,0-5.6,1.3-8.5,2.9
              L172,157c3.6-2.3,8-4.1,12.9-4.1c7.8,0,11.8,4.7,11.8,13.6V184.5z"
              />
            </motion.svg>

            {/* cloud 구름 */}
            <motion.svg className="icon6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.5 283.5">
              <motion.path
                initial={{ y: 200, opacity: 0 }}
                animate={[{ y: 0, opacity: 1 }]}
                style={{ filter: "contrast(1.5)" }}
                transition={{
                  duration: 3,
                  ease: "easeInOut",
                  repeat: 0,
                  repeatType: "loop",
                  repeatDelay: 5,
                  delay: 2,
                }}
                strokeWidth={2}
                strokeDasharray="0 1"
                stroke="#fff"
                fill="#fff"
                d="M203.1,171.4c0,6.3,2.3,9.5,6.3,9.5c2.1,0,3.9-0.9,5.7-3.2v-13.4c-1.9-1.7-3.8-2.3-5.7-2.3
              C206,162,203.1,165.3,203.1,171.4z M140.4,162c-4.2,0-6.5,3.8-6.5,9.5c0,5.8,2.3,9.5,6.5,9.5s6.5-3.7,6.5-9.5C146.9,165.8,144.6,162,140.4,162z M226.4,130.5c-3,0-5.8,0.3-8.6,1c-3-35.2-31.9-62.8-67.1-62.8c-29,0-53.7,18.6-63.2,44.8c-0.4,0-0.8,0-1.2,0
              c-26.2,0-47.5,21.7-47.5,48.5c0,26.8,21.3,48.5,47.5,48.5h140.1c21.6,0,39.1-17.9,39.1-39.9C265.6,148.4,248,130.5,226.4,130.5z
               M91.7,187.5c-10.2,0-18.5-7.3-18.5-20.8c0-13.3,8.6-21.1,18.8-21.1c5.1,0,9.2,2.5,11.9,5.2l-4.2,5.1c-2.1-2-4.4-3.4-7.5-3.4
              c-6.1,0-10.7,5.2-10.7,13.9c0,8.8,4.2,14.1,10.5,14.1c3.5,0,6.2-1.6,8.4-4l4.3,5C101.3,185.5,97,187.5,91.7,187.5z M118,187.5
              c-5.6,0-7.5-3.7-7.5-9.3v-35h8v35.3c0,1.9,0.8,2.5,1.6,2.5c0.3,0,0.5,0,1.1-0.1l1,6C121.2,187.2,119.9,187.5,118,187.5z
               M140.4,187.5c-7.6,0-14.7-5.9-14.7-16.1c0-10.2,7-16.1,14.7-16.1s14.7,5.9,14.7,16.1C155.1,181.6,148.1,187.5,140.4,187.5z
               M188,186.8h-6.6l-0.6-4.4h-0.2c-2.6,3.1-5.6,5.1-9.7,5.1c-6.6,0-9.4-4.6-9.4-12.2v-19.1h8v18.1c0,4.7,1.3,6.4,4.3,6.4
              c2.5,0,4.2-1.1,6.2-3.8v-20.6h8V186.8z M223.2,186.8h-6.5l-0.6-3.2h-0.2c-2.2,2.2-5.3,3.9-8.5,3.9c-7.6,0-12.5-6-12.5-16.1
              c0-9.9,6.2-16.1,12.8-16.1c3.4,0,5.6,1.3,7.8,3.3l-0.3-4.8v-10.8h8V186.8z"
              />
            </motion.svg>

            {/* 공새로 로고 */}
            {/* <motion.svg className="mv_fix_icon5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.5 283.5">
            <motion.path
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{
                duration: 3,
                ease: "easeInOut",
                repeat: Infinity,
                repeatType: "loop",
                repeatDelay: 5,
                delay: 2,
              }}
              style={{ opacity: 0.3 }}
              strokeWidth={1}
              strokeDasharray="0 1"
              stroke="#fbffc8"
              fill="transparent"
              d="M264.7,133.5L264.7,133.5c-2.1-66.3-56.6-119.6-123.4-119.6c-68.1,0-123.4,55.4-123.4,123.4h0
              c0,1.2,0,2.5,0,3.2c1.7,66.6,56.4,120.2,123.4,120.2c66.7,0,121.2-53.2,123.3-119.4h0C264.7,141.4,264.8,137.7,264.7,133.5z
               M256.6,133.5l-111.2-0.2V22.1C205.8,24.2,254.6,73,256.6,133.5z M137.3,133.3H31.7L137.3,27.7V133.3z M131.1,22.5L26.4,127.1
              C31.3,71.7,75.6,27.4,131.1,22.5z M26.1,141.4h111.2v111.2C76.9,250.5,28.2,201.8,26.1,141.4z M145.3,252.6V147.1l74.6,74.6
              C200.2,240.1,174.1,251.6,145.3,252.6z M225.6,216l-74.6-74.6h105.5C255.6,170.2,244,196.3,225.6,216z"
            />
          </motion.svg> */}
          </div>
        </div>
      </div>
      {demoModal && <DemoModal demoModal={demoModal} setDemoModal={setDemoModal} />}
    </>
  );
}
